import { FC } from 'react';
import styles from 'partials/card/subscription-card.module.scss';

export const SkeletonViewPayment: FC = () => {
	// Skeleton style
	const skeletonStyle = {
		minHeight: '20px',
		width: '120px'
	};

	return (
		<div className="d-flex" style={{ gap: '100px' }}>
			<div>
				<div className={styles.row}>
					<span className={styles.rowLabel}>
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
					<span className="fs-6 text-primary">
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
				</div>
				<div className={styles.row}>
					<span className={styles.rowLabel}>
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
					<span>
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
				</div>
				<div className={styles.row}>
					<span className={styles.rowLabel}>
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
					<span>
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
				</div>
				<div className={styles.row}>
					<span className={styles.rowLabel}>
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>

					<span className="skeletonStyle" style={skeletonStyle} />
				</div>
			</div>
			<div>
				<div className={styles.row}>
					<span className={styles.rowLabel}>
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
					<div className="d-flex gap-2 fs-sm text-gray-3">
						<span className="skeletonStyle" style={skeletonStyle} />
					</div>
				</div>
			</div>
		</div>
	);
};
